import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'src/react/components/buttons';
import { ideaShape } from 'src/api/task';

const Details = ({ content, onClick }) => (
  <div className="flex flex-col items-center justify-center wx-12">
    <div className="mb-5">
      <h1 className="font-semibold leading-none text-8">{content.title}</h1>
      <p className="text-5 mb-5">{content.summary}</p>
      <h2 className="text-5">All About This Recommendation</h2>
      <p className="text-3">{content.description}</p>
    </div>
    <div>
      <Button
        className="bg-blue-40 text-4 text-white font-semibold py-2 px-9 inline-block"
        onClick={onClick}
        data-testid="details_close"
      >
        Close
      </Button>
    </div>
  </div>
);

Details.propTypes = {
  content: ideaShape,
  onClick: PropTypes.func
};

export default Details;
